<template>
    <div>
        <DCard>
            <Teleport
                v-if="tableRendered"
                to="table tr th:nth-child(1)"
            >
                <DFormCheck
                    v-model="allIps"
                    class="absolute-checkbox"
                    :checked="ids.length === allowedIpsData.length"
                    @change="updateAllCheckboxes"
                />
            </Teleport>
            <DTable
                :columns="fields"
                :items="allowedIpsData"
                class="min-height"
            >
                <template #checkbox="{item}">
                    <td>
                        <DFormCheck
                            :id="String(item.id)"
                            :checked="ids.includes(item.id)"
                            @change="updateCheckboxArray(item.id)"
                        />
                    </td>
                </template>
                <template #created="{item}">
                    <td>
                        {{ $formatDateTime(item.created) }}
                    </td>
                </template>
            </DTable>
        </DCard>
        <AddIpRangeModal
            :show-modal="showIpRangeModal"
            :owner-group="ownerGroup"
            @close="showIpRangeModal=false"
            @update:allowedIps="updateAllowedIps"
        />
        <IpRangeDeleteModal
            :show-modal="showIpRangeDeleteModal"
            @delete-confirmed="handleIpRangeDelete"
        />

        <DFabs>
            <DFab
                icon="plus"
                :label="$t('settings_allowed_ips.add_ip_range')"
                @click="showIpRangeModal = true"
            />
            <DFab
                v-if="ids.length > 0"
                icon="delete"
                :label="$t('common.remove')"
                @click="showIpRangeDeleteModal = true"
            />
        </DFabs>
    </div>
</template>
<script setup>
import AddIpRangeModal from '~@/Components/Settings/Modals/AddIpRangeModal'
import { router } from '@inertiajs/vue3'
import IpRangeDeleteModal from '~@/Components/Settings/Modals/IpRangeDeleteModal.vue'
import { ref, computed, onMounted, getCurrentInstance } from 'vue'

const { proxy } = getCurrentInstance()

const props = defineProps({
    allowedIps: {
        type: Array,
        default: () => {
            return []
        }
    },
    ownerGroup: {
        type: Number,
        default: null
    }
})

onMounted(() => {
    tableRendered.value = true
})

const fields = computed(() => [
    { key: 'checkbox', label: '', sorter: false, filter: true },
    { key: 'fromIp', label: proxy.$t('settings_allowed_ips.from_ip'), sorter: false, filter: false },
    { key: 'toIp', label: proxy.$t('settings_allowed_ips.to_ip'), sorter: false, filter: false },
    { key: 'created', label: proxy.$t('settings_allowed_ips.created'), sorter: true, filter: true }
])
const ids = ref([])
const showIpRangeModal = ref(false)
const showIpRangeDeleteModal = ref(false)
const allIps = ref(false)
const tableRendered = ref(false)
const allowedIpsData = ref(props.allowedIps)

function updateCheckboxArray (item, allowRemoving = true) {
    if (ids.value.includes(item) && allowRemoving) {
        ids.value = ids.value.filter(value => value !== item)
    } else if (!ids.value.includes(item)) {
        ids.value.push(item)
    }
}

function updateAllCheckboxes () {
    if (ids.value.length === allowedIpsData.value.length) {
        ids.value = []

        return
    }

    allowedIpsData.value.forEach(
        item => updateCheckboxArray(item.id, !allIps.value)
    )
}

function updateAllowedIps (data) {
    allowedIpsData.value = data
}

function handleIpRangeDelete () {
    router.delete(route('settings.allowed-ips.delete', { ipRanges: ids.value }), { preserveState: false })
}

</script>

<style>
.absolute-checkbox {
    z-index: 1000;
    position: absolute;
    top: 2.1rem;
    left: 2rem;
}
.min-height .table-responsive {
    min-height: 47vh !important;
}
</style>
